module.exports = __webpack_public_path__ + "img/wx_icon_default.1901aad9.png";